import { HttpContext, HttpContextToken, HttpRequest } from '@angular/common/http';
import { WithContextOptions, extractHttpContextAndValue } from '../http/http-context.model';

const WITH_AUTHENTICATION = new HttpContextToken<boolean>(() => true);

type WithContextAuthenticationOptions<T = any> = T extends object ? WithContextOptions<{ authentication?: boolean }> : boolean;
export function withAuthentication<T = any>(options?: WithContextAuthenticationOptions<T>) {
  const { context, value } = extractHttpContextAndValue(options);
  const hasAuthentication = typeof value === 'boolean' ? value : value?.authentication;
  return context.set(WITH_AUTHENTICATION, hasAuthentication);
}

export function hasAuthentication(req: HttpRequest<unknown>) {
  return req.context.get(WITH_AUTHENTICATION) !== false;
}

// Marks a request whose 401 must NOT trigger the global auto-logout. Used for
// the profile load during app init: the caller (AuthService.initAuth) handles
// the failure itself instead of firing an MSAL logout redirect, which would
// bounce the user to Microsoft's "pick an account to sign out" screen.
const SKIP_AUTO_LOGOUT = new HttpContextToken<boolean>(() => false);

export function withoutAutoLogout(context: HttpContext = new HttpContext()) {
  return context.set(SKIP_AUTO_LOGOUT, true);
}

export function shouldSkipAutoLogout(req: HttpRequest<unknown>) {
  return req.context.get(SKIP_AUTO_LOGOUT) === true;
}
